const errorMessage = 'bufferFailed: videoBuffer failed to load or timeout';

const isAmrVideoBufferError = ({ message }) => message === errorMessage;

const createAmrVideoBufferError = () => new Error(errorMessage);

export { isAmrVideoBufferError, createAmrVideoBufferError };
